module.exports = __webpack_public_path__ + "img/network-icon.9e6a16d7.svg";